
  import { useStore } from 'vuex'
  import { computed, defineComponent, ref } from 'vue'
  import moment from 'moment'
  import { CompanyModel } from '@/services/api/models1'
  import IndividualContactDisplay from './IndividualDisplay.vue'
  import ProfessionalContactDisplay from './ProfessionalDisplay.vue'
  import InvestorContactDisplay from './InvestorDisplay.vue'
  import { CONTACTTYPE } from '@/types'
  import { useRoute, useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import Modal from '@/components/Modal/Modal.vue'
  import { TYPE } from 'vue-toastification'
  import { Button } from '@up.law/uplaw-ui'

  export default defineComponent({
    name: 'ContactCard',
    components: {
      IndividualContactDisplay,
      ProfessionalContactDisplay,
      InvestorContactDisplay,
      Modal,
      Button
    },
    directives: {},
    props: {
      contact: {
        type: Object,
        required: true
      },
      noPadding: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    emits: ['update-contact-list'],
    setup(props, { emit }) {
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const { t } = useI18n()
      const canDelete = ref(false)
      const showCardSecondary = ref(true)
      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )

      const contactId = ref()

      const handleDeletion = (id: string) => {
        contactId.value = id
        canDelete.value = id !== null
      }

      const submitDeletion = () => {
        store.dispatch(`organizations/DELETE_CONTACT`, {
          companyId: currentCompany.value.id,
          contactId: contactId.value,
          onError: (error = null) => {
            const message = error || t(`contactBook.apiResponse.deleteError`)
            store.dispatch('toolbox/displayToast', {
              type: TYPE.ERROR,
              context: t('contactBook.form.title'),
              message
            })
          },
          onSuccess: () => {
            contactId.value = null
            store.commit('organizations/SET_CURRENT_CONTACT', null)
            emit('update-contact-list')
            router.push({
              name: 'company.directory',
              params: { id: route.params.id }
            })
            store.dispatch('toolbox/displayToast', {
              type: TYPE.SUCCESS,
              context: t('contactBook.form.title'),
              message: t(`contactBook.apiResponse.deleteSuccess`)
            })
          }
        })
      }
      return {
        CONTACTTYPE,
        showCardSecondary,
        canDelete,
        currentCompany,
        moment,
        handleDeletion,
        submitDeletion
      }
    }
  })
